import planeIcon from './assets/plane.svg';
import starIcon from './assets/star.svg';
import type { FreedomLoyaltyLevelInfo, CashbackDetails } from './types';

export const FREEDOM_LOYALTY_LEVELS: Array<FreedomLoyaltyLevelInfo> = [
  {
    title: 'Platinum',
    cashback: 4,
    limitPerTransaction: 30000,
    limitPerMonth: 200000,
  },
  {
    title: 'Gold',
    cashback: 3,
    limitPerTransaction: 20000,
    limitPerMonth: 150000,
  },
  {
    title: 'Silver',
    cashback: 2,
    limitPerTransaction: 7000,
    limitPerMonth: 100000,
  },
  {
    title: 'Standard',
    cashback: 1,
    limitPerTransaction: 5000,
    limitPerMonth: 50000,
  },
];

export const PARTNER_CASHBACK: CashbackDetails = {
  amount: 7,
  key: 'partnership',
  icon: planeIcon,
};

export interface CashbackTypeConfig {
  key: string;
  icon: string;
  keywords: string[];
}

export const CASHBACK_BREAKDOWN_CONFIG: CashbackTypeConfig[] = [
  {
    key: 'level',
    icon: starIcon,
    keywords: ['уровень лояльности', 'базового кешбэка'],
  },
  {
    key: 'partnership',
    icon: planeIcon,
    keywords: ['партнера', 'партнерского'],
  },
];
